<template>
  <ul class="list--inline">
    <li v-for="item in list" :key="item.name">
        <BasicButton class="label" tag="span" size="small" type="blue-light">
            {{item.name}} <button @click="removeItem(item)" class="remove-button"><i class="close-icon icons8-jobapp-delete-01"></i> </button>
        </BasicButton>
    </li>
  </ul>
</template>

<script>
    import BasicButton from '../BasicButton'

    export default {
        name: 'jobs-active-filters',
        components: {
            BasicButton
        },
        props: {
            list: {
                type: Array,
                required: true
            }
        },
        methods: {
            removeItem(item) {
                this.$emit('remove', item)
            }
        },
    }
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/mixins";

    .label {
        margin-right: 14px;
        margin-bottom: 14px;
    }

    .remove-button {
        @include button-reset;
    }

</style>



// WEBPACK FOOTER //
// src/components/jobs/JobsActiveFilters.vue